<template>
    <div id="main-wrapper" data-theme="light" data-layout="vertical" data-navbarbg="skin6" data-sidebartype="overlay"
         data-sidebar-position="fixed" data-header-position="fixed" data-boxed-layout="full">
        <!-- ============================================================== -->
        <!-- Topbar header - style you can find in pages.scss -->
        <!-- ============================================================== -->

        <header class="topbar" data-navbarbg="skin6">
            <nav class="navbar top-navbar navbar-expand-md navbar-light">
                <div class="navbar-header" data-logobg="skin6">
                    <!-- This is for the sidebar toggle which is visible on mobile only -->
                    <a class="nav-toggler waves-effect waves-light d-block d-md-none" href="javascript:void(0)">
                        <i class="ti-menu ti-close"></i>
                    </a>
                    <router-link to="/apps/users" class="text-center navbar-brand">
                        <!-- Logo icon -->
                        <img src="@/assets/images/logos/logo-full.png" alt>
                        <!--End Logo icon -->
                    </router-link>
                </div>
                <!-- ============================================================== -->
                <!-- End Logo -->
                <!-- ============================================================== -->
                <div id="navbarSupportedContent" class="navbar-collapse collapse" data-navbarbg="skin6">
                    <!-- ============================================================== -->
                    <!-- toggle and nav items -->
                    <!-- ============================================================== -->
                    <ul class="float-left mr-auto navbar-nav"></ul>
                    <!-- ============================================================== -->
                    <!-- Right side toggle and nav items -->
                    <!-- ============================================================== -->
                    <ul class="float-right navbar-nav">
                        <!-- ============================================================== -->
                        <!-- Search -->
                        <!-- ============================================================== -->
                        <li class="nav-item search-box">
                            <form class="app-search d-none d-lg-block">
                                <input type="text" class="form-control" placeholder="Search...">
                                <a href class="active">
                                    <i class="fa fa-search"></i>
                                </a>
                            </form>
                        </li>
                        <!-- ============================================================== -->
                        <!-- User profile and search -->
                        <!-- ============================================================== -->
                        <li class="nav-item dropdown">
                            <a class="nav-link dropdown-toggle waves-effect waves-dark pointer"
                               @click.stop="toggleDropdownProfile">
                                <img :src="$store.state.currentUser.avatar" alt="user" class="rounded-circle"
                                     width="36">
                                <span class="ml-2 font-medium">{{
                                        $store.state.currentUser.firstName
                                    }} {{ $store.state.currentUser.lastName }}</span>
                                <span class="ml-2 fas fa-angle-down"></span>
                            </a>
                            <div v-if="dropdownProfile"
                                 v-click-outside="toggleDropdownProfile" class="dropdown-menu dropdown-menu-right user-dd animated flipInY show">
                                <div class="p-3 mb-2 d-flex no-block align-items-center border-bottom">
                                    <div class>
                                        <img :src="$store.state.currentUser.avatar" alt="user" class="rounded"
                                             width="80">
                                    </div>
                                    <div class="ml-2">
                                        <h4 class="mb-0">{{ $store.state.currentUser.firstName }}
                                            {{ $store.state.currentUser.lastName }}</h4>
                                        <p class="mb-0 text-muted">{{ $store.state.currentUser.email }}</p>
                                        <a href="javascript:void(0)"
                                           class="mt-2 text-white btn btn-sm btn-danger btn-rounded">View Profile</a>
                                    </div>
                                </div>
                                <a class="dropdown-item" href="javascript:void(0)">
                                    <i class="ml-1 mr-1 ti-user"></i> My Profile
                                </a>
                                <a class="dropdown-item" href="javascript:void(0)">
                                    <i class="ml-1 mr-1 ti-wallet"></i> My Balance
                                </a>
                                <a class="dropdown-item" href="javascript:void(0)">
                                    <i class="ml-1 mr-1 ti-email"></i> Inbox
                                </a>
                                <div class="dropdown-divider"></div>
                                <a class="dropdown-item" href="javascript:void(0)">
                                    <i class="ml-1 mr-1 ti-settings"></i> Account Setting
                                </a>
                                <div class="dropdown-divider"></div>
                                <a class="dropdown-item pointer" @click="logout">
                                    <i class="ml-1 mr-1 fa fa-power-off"></i> Logout
                                </a>
                            </div>
                        </li>
                        <!-- ============================================================== -->
                        <!-- User profile and search -->
                        <!-- ============================================================== -->
                    </ul>
                </div>
            </nav>
        </header>

        <aside class="left-sidebar" data-sidebarbg="skin5">
            <!-- Sidebar scroll-->
            <div class="scroll-sidebar ps-container ps-theme-default ps-active-y style-1"
                 data-ps-id="afdf6b18-6000-32d7-d6af-87e54fa69597">
                <!-- Sidebar navigation-->
                <nav class="sidebar-nav">
                    <ul id="sidebarnav" class="in">
                        <li class="sidebar-item">
                            <a class="sidebar-link waves-effect waves-dark profile-dd">
                                <img :src="$store.state.currentUser.avatar" class="ml-2 rounded-circle" width="30">
                                <span class="hide-menu">{{
                                        $store.state.currentUser.firstName
                                    }} {{ $store.state.currentUser.lastName }}</span>
                                <span class="badge badge-primary">{{ $store.state.currentUser.role }}</span>
                            </a>
                        </li>
                        <router-link to="/apps/users" tag="li" router-link-active="selected"
                                     class="sidebar-item pointer">
                            <a class="sidebar-link waves-effect waves-dark">
                                <i class="fa fa-user fa-fw"></i>
                                <span class="hide-menu">Users</span>
                            </a>
                        </router-link>
                        <router-link to="/apps/notification" tag="li" router-link-active="selected"
                                     class="sidebar-item pointer">
                            <a class="sidebar-link waves-effect waves-dark">
                                <i class="fa fa-bell" aria-hidden="true"></i>
                                <span class="hide-menu">Notifications</span>
                            </a>
                        </router-link>
                        <router-link to="/apps/wordpress-cache" tag="li" router-link-active="selected"
                                     class="sidebar-item pointer">
                            <a class="sidebar-link waves-effect waves-dark">
                                <i class="fab fa-wordpress"></i>
                                <span class="hide-menu">Wordpress Cache</span>
                            </a>
                        </router-link>
                        <router-link to="/apps/links-generator" tag="li" router-link-active="selected"
                                     class="sidebar-item pointer">
                            <a class="sidebar-link waves-effect waves-dark">
                                <i class="fa fa-link fa-fw"></i>
                                <span class="hide-menu">Links Generator</span>
                            </a>
                        </router-link>
                        <router-link to="/apps/templates" tag="li" router-link-active="selected"
                                     class="sidebar-item pointer">
                            <a class="sidebar-link waves-effect waves-dark">
                                <i class="fa fa-file fa-fw"></i>
                                <span class="hide-menu">Templates</span>
                            </a>
                        </router-link>
                        <router-link to="/apps/templates-categories" tag="li" router-link-active="selected"
                                     class="sidebar-item pointer">
                            <a class="sidebar-link waves-effect waves-dark">
                                <i class="fa fa-file fa-fw"></i>
                                <span class="hide-menu">Template Categories</span>
                            </a>
                        </router-link>
                        <router-link to="/apps/template-collections" tag="li" router-link-active="selected"
                                     class="sidebar-item pointer">
                            <a class="sidebar-link waves-effect waves-dark">
                                <i class="fa fa-file fa-fw"></i>
                                <span class="hide-menu">Template Collections</span>
                            </a>
                        </router-link>
                        <router-link to="/apps/presentation-themes" tag="li" router-link-active="selected"
                                     class="sidebar-item pointer">
                            <a class="sidebar-link waves-effect waves-dark">
                                <i class="fa fa-paint-brush"></i>
                                <span class="hide-menu">Presentation Themes</span>
                            </a>
                        </router-link>
                        <router-link to="/apps/teams" tag="li" router-link-active="selected"
                                     class="sidebar-item pointer">
                            <a class="sidebar-link waves-effect waves-dark">
                                <i class="fa fa-users fa-fw"></i>
                                <span class="hide-menu">Teams</span>
                            </a>
                        </router-link>
                        <router-link to="/apps/presentations" tag="li" router-link-active="selected"
                                     class="sidebar-item pointer">
                            <a class="sidebar-link waves-effect waves-dark">
                                <i class="fa fa-list fa-fw"></i>
                                <span class="hide-menu">Presentations</span>
                            </a>
                        </router-link>
                        <router-link to="/apps/stickers" tag="li" router-link-active="selected"
                                     class="sidebar-item pointer">
                            <a class="sidebar-link waves-effect waves-dark">
                                <i class="fa fa-image fa-fw"></i>
                                <span class="hide-menu">Stickers</span>
                            </a>
                        </router-link>
                        <router-link to="/apps/survey-management" tag="li" router-link-active="selected"
                                     class="sidebar-item pointer">
                            <a class="sidebar-link waves-effect waves-dark">
                                <i class="fa fa-comment fa-fw"></i>
                                <span class="hide-menu">Survey Management</span>
                            </a>
                        </router-link>
                        <router-link to="/apps/crawl" tag="li" router-link-active="selected"
                                     class="sidebar-item pointer">
                            <a class="sidebar-link waves-effect waves-dark">
                                <i class="fa fa-database fa-fw"></i>
                                <span class="hide-menu">Crawl data</span>
                            </a>
                        </router-link>
                        <router-link to="/apps/ads-campaign" tag="li" router-link-active="selected"
                                     class="sidebar-item pointer">
                            <a class="sidebar-link waves-effect waves-dark">
                                <i class="fas fa-credit-card fa-fw"></i>
                                <span class="hide-menu">Ads Campaign</span>
                            </a>
                        </router-link>
                        <router-link to="/apps/global-configuration" tag="li" router-link-active="selected"
                                     class="sidebar-item pointer">
                            <a class="sidebar-link waves-effect waves-dark">
                                <i class="fa fa-cog"></i>
                                <span class="hide-menu">Global Configuration</span>
                            </a>
                        </router-link>
                        <li class="sidebar-item pointer">
                            <a class="sidebar-link waves-effect waves-dark" @click="logout">
                                <i class="fa fa-sign-out-alt fa-fw"></i>
                                <span class="hide-menu">Log Out</span>
                            </a>
                        </li>
                    </ul>
                </nav>
                <!-- End Sidebar navigation -->
            </div>
            <!-- End Sidebar scroll-->
        </aside>

        <div class="page-wrapper" style="display: block">
            <router-view/>
            <footer class="text-center footer">
                All Rights Reserved by Ahaslides. Designed and Developed by
                <a>Mind The Gap studio</a>.
            </footer>
        </div>
    </div>
</template>

<script>
// @ is an alias to /src
import Config from '@/config'

export default {
  name: 'Main',
  data() {
    return {
      dropdownProfile: false
    }
  },
  created() {
    this.$http.get(Config.api.getProfile).then(
      res => {
        this.$store.dispatch('setCurrentUser', res.body)
        this.$cookie.set('ahaUserAdmin', res.body)
      },
      err => {
        if (err.status == 401) {
          this.$store.dispatch('logout')
        }
      }
    )
  },

  methods: {
    logout() {
      this.$store.dispatch('logout')
    },
    toggleDropdownProfile() {
      this.dropdownProfile = !this.dropdownProfile
    },
  }
}
</script>

<style lang="scss" scoped>
.style-1::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: #f5f5f5;
}

.style-1::-webkit-scrollbar {
  width: 12px;
  background-color: #f5f5f5;
}

.style-1::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #555;
}

.selected a {
  background-color: #4f9af2 !important;
}

#main-wrapper .page-wrapper {
  padding-top: 70px;
}

.left-sidebar {
  overflow-y: auto;
}

.badge-primary {
  background-color: #4f9af2;
}

.navbar-brand {
  width: 100%;
  background-color: #fff;
  padding-left: 17px;
  margin: 0;

  img {
    max-height: 50px;
    margin: 0;
    width: 152px;
    margin-top: 16px;
  }
}

.top-navbar {
  background-color: #fff;
}
</style>

